export const FIELDS_CACHE_KEY = 'fieldsCache';

/** Limpia tokens y caché de listado de campos (p. ej. al cerrar sesión). */
export function clearAuthSession() {
  localStorage.removeItem('accessToken');
  localStorage.removeItem('refreshToken');
  sessionStorage.removeItem(FIELDS_CACHE_KEY);
}
